export default "__VITE_ASSET__cpbFB3QR__"